// LifeIQ Level 3 · Life Design — 5-book retail series.
// All titles, subtitles, page counts, chapters and tool names are sourced
// directly from the five CLEAN authoritative PDFs supplied by the owner.
// PRICING APPROVED (Command 03) — Standard Checkout reused, entitlements
// mapped 1:1 per book + bundle, no new Razorpay Payment Pages created.

export const LEVEL3_PRICE_STATUS = "APPROVED";
export const LEVEL3_PAYMENTS_DISABLED = false;

// Shared visual language derived from the five actual covers (navy / cream /
// gold / teal), with blue and green pulled from Book 2 and Book 3's covers.
// Deliberately distinct from both Chinnu (orange/cream) and Cyber Safety
// (navy/gold/teal/red) — same family, different balance and no red.
export const LEVEL3_ACCENT = {
  navy: "#10203A",
  cream: "#F7F3EA",
  gold: "#C8862E",
  teal: "#2F8577",
  textMuted: "#5C6676",
};

export const LEVEL3_SERIES = {
  name: "LifeIQ Level 3 · Life Design",
  eyebrow: "LifeIQ · Real-World Life Skills for Teens",
  headline: ["Five books.", "One working system for real life."],
  audience: "For Teens & Young Adults",
  progression: ["Know Yourself", "Work With People", "Handle Money", "Grow Wisely", "Build a Life"],
  intro:
    "Five practical self-read books for teens and young adults — built around real situations, memorable tools and decisions that matter outside the classroom.",
  altIntro:
    "From handling yourself and working with people to understanding money, growing wisely and designing the life ahead.",
  totalPages: 489,
  totalBooks: 5,
};

export const LEVEL3_BOOKS = [
  {
    product_id: "LEVEL3-B01",
    slug: "mastering-yourself",
    book_number: 1,
    label: "Book 1 of 5",
    series_step: "Know Yourself",
    title: "Mastering Yourself",
    subtitle: "Emotions · Confidence · Stress · Decisions · Resilience",
    short_description:
      "Practical ways to handle emotion, setbacks, comparison, stress and difficult decisions — without pretending any of them are simple.",
    pages: 103,
    tools_count: 10,
    accent: "#2F8577",
    regular_price: "₹99",
    price: "₹49",
    regular_price_value: 99,
    price_value: 49,
    savings: "₹50",
    offer_label: "Launch Offer",
    format: "Digital PDF",
    order_base: "/books/level3/order",
    disclaimer: "This book offers general educational guidance. It is not therapy and does not diagnose, treat or replace professional mental-health support.",
    cover_asset: "/api/book-assets/covers/mastering-yourself.jpg",
    preview_assets: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/api/book-assets/previews/mastering-yourself/p${n}.jpg`),
    chapters: [
      { name: "The Six-Second Pause", desc: "Name It → Breathe → Hold Off → Choose" },
      { name: "Beyond Marks", desc: "Describe, Don't Define" },
      { name: "When the Answer Is No", desc: "Feel → Shrink → Sort → Choose" },
      { name: "When It Doesn't Work", desc: "Result → Reason → Revision" },
      { name: "The Weight of Comparison", desc: "The Comparison Filter" },
      { name: "Talking to Yourself Like Someone You Respect", desc: "The Respect Test" },
      { name: "Knowing What You Actually Value", desc: "Three Signals → Working Shortlist" },
      { name: "Thinking Clearly When It Counts", desc: "Four Questions Before You Decide" },
      { name: "Stress, Focus and the Cost of Switching", desc: "Empty → Sort → Single-Track" },
      { name: "When to Ask for Help", desc: "The Three-Part Ask" },
    ],
  },
  {
    product_id: "LEVEL3-B02",
    slug: "leading-connecting",
    book_number: 2,
    label: "Book 2 of 5",
    series_step: "Work With People",
    title: "Leading & Connecting",
    subtitle: "Communication · Leadership · Boundaries · Speaking · Relationships",
    short_description:
      "Disagree well, lead without needing a title, set boundaries, speak clearly and build trust through ordinary interactions.",
    pages: 90,
    tools_count: 9,
    accent: "#3E6FB0",
    regular_price: "₹99",
    price: "₹49",
    regular_price_value: 99,
    price_value: 49,
    savings: "₹50",
    offer_label: "Launch Offer",
    format: "Digital PDF",
    order_base: "/books/level3/order",
    cover_asset: "/api/book-assets/covers/leading-connecting.jpg",
    preview_assets: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/api/book-assets/previews/leading-connecting/p${n}.jpg`),
    chapters: [
      { name: "The Art of Disagreeing Well", desc: "Holding your ground without starting a war" },
      { name: "Leading Without a Title", desc: "Nobody appoints you, and you don't need them to" },
      { name: "Saying No, and Meaning It", desc: "The clean refusal, without the apology tour" },
      { name: "Speaking So People Actually Listen", desc: "Why good points get ignored, and how yours lands" },
      { name: "Speaking to a Room", desc: "Nerves aren't the problem" },
      { name: "The Interview Room", desc: "What's actually being asked underneath" },
      { name: "Integrity: Who You Are When No One's Watching", desc: "The small choices nobody sees" },
      { name: "Your Digital Reputation", desc: "A message to people you haven't met yet" },
      { name: "Building Real Relationships", desc: "Built slowly, out of small ordinary things" },
    ],
  },
  {
    product_id: "LEVEL3-B03",
    slug: "money-how-it-really-works",
    book_number: 3,
    label: "Book 3 of 5",
    series_step: "Handle Money",
    title: "Money: How It Really Works",
    subtitle: "Earning · Spending · Payslips · Debt · Insurance · Everyday Money",
    short_description:
      "Understand first income, payslips, spending, debt, insurance and the money paperwork most people meet before anyone explains it.",
    pages: 110,
    tools_count: 8,
    accent: "#2F7D5C",
    regular_price: "₹129",
    price: "₹69",
    regular_price_value: 129,
    price_value: 69,
    savings: "₹60",
    offer_label: "Launch Offer",
    format: "Digital PDF",
    order_base: "/books/level3/order",
    disclaimer: "Educational awareness only. Not financial, tax, legal or insurance advice.",
    updatesUrl: "/books/level3/updates#book-3",
    cover_asset: "/api/book-assets/covers/money-how-it-really-works.jpg",
    preview_assets: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/api/book-assets/previews/money-how-it-really-works/p${n}.jpg`),
    chapters: [
      { name: "Your First Real Income", desc: "Now → Soon → Later/Buffer" },
      { name: "Your First Payslip", desc: "Package → Gross → Deductions → Net" },
      { name: "Where Your Money Actually Goes", desc: "Track → Group → One Change" },
      { name: "Money Between People", desc: "Amount → Terms → Record" },
      { name: "Credit, Debt and Staying Free of It", desc: "Total → Terms → Failure Case → Purpose" },
      { name: "Insurance, Understood", desc: "Risk → Cover → Limits → Exclusions → Claim" },
      { name: "Tax, Nominations, Wills and Protecting What's Yours", desc: "Earn → Check → Prove → Pass On" },
      { name: "What Are You Really Paying For?", desc: "All-In Price → Alternatives → Value → Responsibility" },
    ],
  },
  {
    product_id: "LEVEL3-B04",
    slug: "money-that-grows",
    book_number: 4,
    label: "Book 4 of 5",
    series_step: "Grow Wisely",
    title: "Money That Grows",
    subtitle: "Investing · Compounding · Shares · Funds · Business · Entrepreneurship",
    short_description:
      "Understand compounding, investing and business without hype, tips or promises of quick returns.",
    pages: 115,
    tools_count: 9,
    accent: "#C8862E",
    regular_price: "₹129",
    price: "₹69",
    regular_price_value: 129,
    price_value: 69,
    savings: "₹60",
    offer_label: "Launch Offer",
    format: "Digital PDF",
    order_base: "/books/level3/order",
    disclaimer: "Educational awareness only. Not investment, tax or legal advice. No guaranteed returns.",
    cover_asset: "/api/book-assets/covers/money-that-grows.jpg",
    preview_assets: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/api/book-assets/previews/money-that-grows/p${n}.jpg`),
    chapters: [
      { name: "The Power of Compounding", desc: "The Doubling Clock" },
      { name: "Investing 101: Stocks & Shares", desc: "The Part-Owner Test" },
      { name: "Mutual Funds, SIPs & ETFs", desc: "The Basket Rule" },
      { name: "Investing vs. Trading", desc: "The Ten-Year Question" },
      { name: "How Businesses Actually Make Money", desc: "Follow the Rupee" },
      { name: "Inside Real Companies", desc: "The Model Map" },
      { name: "Thinking Like an Entrepreneur", desc: "Problem First" },
      { name: "Funding vs. Doing It Yourself", desc: "The Cost of Money" },
      { name: "Contracts and Fine Print", desc: "The Fine-Print Five" },
    ],
  },
  {
    product_id: "LEVEL3-B05",
    slug: "your-path-long-game",
    book_number: 5,
    label: "Book 5 of 5",
    series_step: "Build a Life",
    title: "Your Path & The Long Game",
    subtitle: "Career · Work · Health · Relationships · Purpose · Life Design",
    short_description:
      "Bring together direction, skills, work, health, relationships, values and the kind of life you actually want to build.",
    pages: 71,
    tools_count: 9,
    accent: "#4A6FA5",
    regular_price: "₹99",
    price: "₹49",
    regular_price_value: 99,
    price_value: 49,
    savings: "₹50",
    offer_label: "Launch Offer",
    format: "Digital PDF",
    order_base: "/books/level3/order",
    closesWith: ["The Level 3 Master Toolkit", "Your One-Year Life Experiment"],
    cover_asset: "/api/book-assets/covers/your-path-long-game.jpg",
    preview_assets: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/api/book-assets/previews/your-path-long-game/p${n}.jpg`),
    chapters: [
      { name: "Choosing What to Study (Or Not)", desc: "The Three-Circle Check" },
      { name: "The Internship and the Real Resume", desc: "The Proof Ledger" },
      { name: "Getting Things Done Without Burning Out", desc: "The Weekly Reality Planner" },
      { name: "Your Body Is Part of the Plan", desc: "The Energy Audit" },
      { name: "Relationships That Help You Grow", desc: "The Relationship Compass" },
      { name: "Meaning, Values & What Matters to You", desc: "The Values Stack" },
      { name: "Designing the Whole Life", desc: "The Whole-Life Dashboard" },
      { name: "Thinking Beyond Yourself", desc: "The Contribution Map" },
      { name: "Build Something Real", desc: "The Build Something Real Canvas" },
    ],
  },
];

export const LEVEL3_BUNDLE = {
  product_id: "LEVEL3-BUNDLE-05",
  slug: "complete-series",
  download_slug: "level3-complete-series",
  title: "The Complete Level 3 · Life Design Series",
  description:
    "Five books designed to work individually — and even better as one complete real-life system.",
  totalPages: 489,
  totalBooks: 5,
  regular_price: "₹555",
  price: "₹249",
  regular_price_value: 555,
  price_value: 249,
  savings: "₹306",
  offer_label: "Complete Series Offer",
  format: "Digital PDF",
  order_base: "/books/level3/order",
  individual_launch_total: 285,
  bundle_extra_saving: 36,
};

export const LEVEL3_WHY_DIFFERENT = [
  { n: "01", title: "Real Situations", body: "Each chapter begins with moments young people may actually recognise." },
  { n: "02", title: "Memorable Tools", body: "The reader leaves with simple frameworks they can remember and reuse." },
  { n: "03", title: "Start Where You Need", body: "Each book stands on its own and can be entered through a situation happening now." },
  { n: "04", title: "One Complete Journey", body: "Across five books: self → people → money → growth → life design." },
];

export const LEVEL3_SUPPORT = {
  email: "LifeIqedtech@gmail.com",
  whatsapp: "+91 90591 12617",
  whatsapp_link: "https://wa.me/919059112617",
};

export const LEVEL3_AUTHOR = {
  name: "Kunti Sudheer Bose",
  publisher: "LifeIQ Publications",
  publisherNote: "An imprint of LifeIQ EdTech LLP",
};

// Helpers (mirrors data/books.js and data/cyberSafetyBooks.js conventions)
export const findLevel3Book = (slug) => LEVEL3_BOOKS.find((b) => b.slug === slug);

export const findLevel3Product = (slug) =>
  slug === LEVEL3_BUNDLE.slug || slug === LEVEL3_BUNDLE.download_slug ? LEVEL3_BUNDLE : findLevel3Book(slug);
